import TagTypeList from './TagTypeList';

export default TagTypeList;
